import { locate, getID, env } from "@svar-ui/lib-dom";

type Unsubscribe = () => void;
type EventHandler = (id: string | number, ev: Event) => void;

export function delegateEvent(
	node: HTMLElement,
	handlers: Record<string, EventHandler> | EventHandler,
	event: string
): Unsubscribe {
	function handleEvent(ev: Event) {
		const node = locate(ev);
		if (!node) return;

		const id = getID(node);

		if (typeof handlers === "function") return handlers(id, ev);

		let action;
		let test = ev.target as HTMLElement;
		while (test != node) {
			action = test.dataset ? test.dataset.action : null;
			if (action) {
				if (handlers[action]) {
					handlers[action](id, ev);
					return;
				}
			}
			test = test.parentNode as HTMLElement;
		}
		if (handlers[event]) handlers[event](id, ev);
	}

	return env.addEvent(node, event, handleEvent);
}

export function delegateClick(
	node: HTMLElement,
	handlers: Record<string, EventHandler>
) {
	const result = [delegateEvent(node, handlers, "click")];
	if (handlers.dblclick)
		result.push(delegateEvent(node, handlers.dblclick, "dblclick"));

	return (): void => {
		result.forEach(r => r());
	};
}
